import {i18n} from '@wendig/lib'
import config from '../lib/dotenv'
import {baseUrl} from '../lib/util'
import search from './search.instance'

export default class Section {
  constructor(data) {
    this.d = data
  }

  id() {
    return this.d['Id_OG']
  }

  name() {
    return this.d['Ortsgruppe']
  }

  leaders() {
    const v = this.d['OGL']

    return (
      v ?
      v.split(/\s*;\s*/) :
      null
    )
  }

  people() {
    const v = this.d['names']

    return (
      v ?
      v.split('|') :
      null
    )
  }

  foundedAt() {
    return this.d['gegründet']
  }

  mentioned() {
    const str = this.d['Erwähnung']
    if (!str) return null

    const date = new Date(Date.parse(str))

    return `${date.getDate()}.${date.getMonth()}.${date.getFullYear()}`
  }

  comment() {
    return this.d['Bemerkungen']
  }
}
